import { render, staticRenderFns } from "./standingBook.vue?vue&type=template&id=3991c81f&scoped=true&"
import script from "./standingBook.vue?vue&type=script&lang=js&"
export * from "./standingBook.vue?vue&type=script&lang=js&"
import style0 from "./standingBook.vue?vue&type=style&index=0&id=3991c81f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3991c81f",
  null
  
)

export default component.exports